import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import fr from 'facet-rest';
import Dialog from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Dialog';
import { DialogContent, DialogTitle } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { truncate } from 'lodash';
import { Typography } from '@material-ui/core';

const style = theme => ({
  root: {},
  buttonList: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(3),
    width: theme.dimensions.md,
  },
  downloadButton: {
    marginBottom: theme.spacing(2),
  },
});

const AttachedStatementDownloadButton = ({
  className,
  classes,
  collection,
}) => {
  const [open, setOpen] = useState(false);
  const collectionList = collection.resources().list();
  const fileUrl = collectionList[0]?.relationship(fr.relationships.download.name)?.link('related').url();
  const multipleAttachments = collectionList.length > 1;
  if (collectionList.length === 0) return null;

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(false);
  };

  const handleOpen = (e, file) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(file, '_blank', 'noreferrer noopener nofollow');
  };

  const handleClick = (e, multiple) => {
    e.preventDefault();
    e.stopPropagation();
    if (multiple) {
      setOpen(true);
    } else {
      handleOpen(e, fileUrl);
    }
  };
  if (!fileUrl) return null;
  return (
    <>
      <RoundedButton
        className={classNames(className, classes.root)}
        onClick={(e) => handleClick(e, multipleAttachments)}
        disableElevation
        variant={'contained'}
        color={'accentBlue'}
        size={'sm'}
        padding={'dense'}
      >
        {multipleAttachments ? 'See Attachments' : 'Download'}
      </RoundedButton>
      {multipleAttachments && (
        <Dialog
          open={open}
          showCloseIcon
          onClose={handleClose}
          variant={'modern'}
        >
          <DialogTitle>
            <Typography
              className={classes.title}
              variant={'h2'}
              color={'primary'}
            >
              {'See Attachments'}
            </Typography>
          </DialogTitle>
          <DialogContent className={classes.buttonList}>
            {collectionList.map(attachment => (
              <RoundedButton
                className={classes.downloadButton}
                key={attachment.id()}
                onClick={(e) => handleOpen(e, attachment?.relationship(fr.relationships.download.name).link('related').url())}
                disableElevation
                variant={'contained'}
                color={'accentBlue'}
                size={'sm'}
                padding={'dense'}
              >
                {`Download ${truncate(attachment.attr('name'), {
                  length: 15,
                  omission: '...',
                })
                }`}
              </RoundedButton>
            ))}
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

AttachedStatementDownloadButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  collection: PropTypes.array.isRequired,
};

AttachedStatementDownloadButton.defaultProps = {
  className: '',
};

export default withStyles(style)(AttachedStatementDownloadButton);
